import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MultiTermsBaseContent } from '@shared/services/content/content-jsons/multi-terms-base-content';
import { ContentPages } from '@store/reducers/content/content.reducer';
import { Observable, of } from 'rxjs';

import { AccountTriageContent } from './content-jsons/account-triage-content';
import { AssumeInheritContent } from './content-jsons/assume-inherit-content';
import { BeneDetailsContent } from './content-jsons/bene-details-content';
import { BeneRelationshipContent } from './content-jsons/bene-relationship-content';
import { CancelContent } from './content-jsons/cancel-content';
import { ConfirmContent } from './content-jsons/confirm-content';
import { ContactInfoContent } from './content-jsons/contact-info-content';
import { DateOfBirthContent } from './content-jsons/date-of-birth-content';
import { DateOfDeathContent } from './content-jsons/date-of-death-content';
import { DecedentContent } from './content-jsons/decedent-content';
import { DecedentIdContent } from './content-jsons/decedent-id-content';
import { DocumentUploadContent } from './content-jsons/document-upload-content';
import { EmploymentContent } from './content-jsons/employment-content';
import { ErrorContent } from './content-jsons/error.content';
import { EstateContent } from './content-jsons/estate-content';
import { GiftingIneligibleContent } from './content-jsons/gifting-ineligible-content';
import { IncomeNetWorthContent } from './content-jsons/income-net-worth-content';
import { InheritanceIneligibleContent } from './content-jsons/inheritance-ineligible-content';
import { InheritedIraDecedentInfoContent } from './content-jsons/inherited-ira-decedent-info-content';
import { InheritedIRATriageContent } from './content-jsons/inherited-ira-triage-content';
import { InternalTransferIneligibleContent } from './content-jsons/internal-transfer-ineligible-content';
import { InvestmentObjectivesContent } from './content-jsons/investment-objectives-content';
import { IraTypeContent } from './content-jsons/ira-type-content';
import { LetterUploadContent } from './content-jsons/letter-upload-content';
import { MinorIneligibleContent } from './content-jsons/minor-ineligible-content';
import { MultiTermsNewContent } from './content-jsons/multi-terms-new-content';
import { MultiTriageContent } from './content-jsons/multi-triage-content';
import { MultiTrustTriageContent } from './content-jsons/multi-trust-triage-content';
import { NameContent } from './content-jsons/name-component-content';
import { NewAccountReviewContent } from './content-jsons/new-account-review-content';
import { PersonalIdContent } from './content-jsons/personal-id-content';
import { PersonalInfoContent } from './content-jsons/personal-info-content';
import { ReceiptContent } from './content-jsons/receipt-content';
import { ReviewContent } from './content-jsons/review-content';
import { ReviewSignContent } from './content-jsons/review-sign-content';
import { SharedContent } from './content-jsons/shared-content';
import { TCFTrustSignContent } from './content-jsons/tcf-trust-sign.content';
import { TermsExistingContent } from './content-jsons/terms-existing-content';
import { TermsGiftingContent } from './content-jsons/terms-gifting-content';
import { TermsNewContent } from './content-jsons/terms-new-content';
import { TransferFromContent } from './content-jsons/transfer-from-content';
import { TransferToContent } from './content-jsons/transfer-to-content';
import { TriageContent } from './content-jsons/triage-content';
import { TrustInfoContent } from './content-jsons/trust-info-content';
import { TrustTaxInfoContent } from './content-jsons/trust-tax-info.content';
import { TrustToTrustInfoContent } from './content-jsons/trust-to-trust-info-content';
import { TrustTriageContent } from './content-jsons/trust-triage-content';
import { ZipCodeContent } from './content-jsons/zipcode-content';

export interface CaasDataContent {
  page: {
    metadata: any;
    content: any;
  };
}

export interface CaaSContent {
  LatestModified: number;
  Results: number;
  Error: string;
  Data: CaasDataContent;
}

export const AppContent: ContentPages = {
  accounttriage: AccountTriageContent,
  assumeinherit: AssumeInheritContent,
  benedetails: BeneDetailsContent,
  benerelationship: BeneRelationshipContent,
  cancel: CancelContent,
  confirm: ConfirmContent,
  contactinfo: ContactInfoContent,
  dateofbirth: DateOfBirthContent,
  dateofdeath: DateOfDeathContent,
  decedent: DecedentContent,
  decedentid: DecedentIdContent,
  documentupload: DocumentUploadContent,
  letterupload: LetterUploadContent,
  employment: EmploymentContent,
  error: ErrorContent,
  estate: EstateContent,
  giftingineligible: GiftingIneligibleContent,
  incomenetworth: IncomeNetWorthContent,
  inheritanceineligible: InheritanceIneligibleContent,
  inheritediradecedentinfo: InheritedIraDecedentInfoContent,
  inheritediratriage: InheritedIRATriageContent,
  internaltransferineligible: InternalTransferIneligibleContent,
  investmentobjectives: InvestmentObjectivesContent,
  iratype: IraTypeContent,
  minorineligible: MinorIneligibleContent,
  multitriage: MultiTriageContent,
  multitrusttriage: MultiTrustTriageContent,
  multitermsbase: MultiTermsBaseContent,
  multitermsnew: MultiTermsNewContent,
  namecomponent: NameContent,
  newaccountreview: NewAccountReviewContent,
  personalId: PersonalIdContent,
  personalinfo: PersonalInfoContent,
  receipt: ReceiptContent,
  review: ReviewContent,
  reviewsign: ReviewSignContent,
  shared: SharedContent,
  tcftrustsign: TCFTrustSignContent,
  termsexisting: TermsExistingContent,
  termsnew: TermsNewContent,
  termsgifting: TermsGiftingContent,
  testmonkey: {},
  transferfrom: TransferFromContent,
  transferto: TransferToContent,
  triage: TriageContent,
  trustinfo: TrustInfoContent,
  trusttaxinfo: TrustTaxInfoContent,
  trusttotrustinfo: TrustToTrustInfoContent,
  trusttriage: TrustTriageContent,
  unittest: undefined,
  zipcode: ZipCodeContent,
};

@Injectable({
  providedIn: 'root',
})
export class ContentService {
  http: HttpClient;

  constructor(http: HttpClient) {
    this.http = http;
  }

  /**
   * Load base application content.
   */
  getContent(): Observable<any> {
    return of(AppContent);
  }
}
